(function () {
  'use strict';

  // US ZIP (first 3 digits) -> full state name. 60601 => Illinois.
  var ZIP3_STATE = [
    [6, 9, 'Puerto Rico'],
    [10, 27, 'Massachusetts'],
    [28, 29, 'Rhode Island'],
    [30, 38, 'New Hampshire'],
    [39, 49, 'Maine'],
    [50, 59, 'Vermont'],
    [60, 69, 'Connecticut'],
    [70, 89, 'New Jersey'],
    [100, 149, 'New York'],
    [150, 196, 'Pennsylvania'],
    [197, 199, 'Delaware'],
    [200, 200, 'District of Columbia'],
    [201, 201, 'Virginia'],
    [202, 205, 'District of Columbia'],
    [206, 219, 'Maryland'],
    [220, 246, 'Virginia'],
    [247, 268, 'West Virginia'],
    [270, 289, 'North Carolina'],
    [290, 299, 'South Carolina'],
    [300, 319, 'Georgia'],
    [320, 349, 'Florida'],
    [350, 369, 'Alabama'],
    [370, 385, 'Tennessee'],
    [386, 397, 'Mississippi'],
    [398, 399, 'Georgia'],
    [400, 427, 'Kentucky'],
    [430, 459, 'Ohio'],
    [460, 479, 'Indiana'],
    [480, 499, 'Michigan'],
    [500, 528, 'Iowa'],
    [530, 549, 'Wisconsin'],
    [550, 567, 'Minnesota'],
    [570, 577, 'South Dakota'],
    [580, 588, 'North Dakota'],
    [590, 599, 'Montana'],
    [600, 629, 'Illinois'],
    [630, 658, 'Missouri'],
    [660, 679, 'Kansas'],
    [680, 693, 'Nebraska'],
    [700, 714, 'Louisiana'],
    [716, 729, 'Arkansas'],
    [730, 749, 'Oklahoma'],
    [750, 799, 'Texas'],
    [800, 816, 'Colorado'],
    [820, 831, 'Wyoming'],
    [832, 838, 'Idaho'],
    [840, 847, 'Utah'],
    [850, 865, 'Arizona'],
    [870, 884, 'New Mexico'],
    [889, 898, 'Nevada'],
    [900, 961, 'California'],
    [967, 968, 'Hawaii'],
    [970, 979, 'Oregon'],
    [980, 994, 'Washington'],
    [995, 999, 'Alaska']
  ];

  var FAIL_MSG = 'Checkout will still show the real UPS rate.';

  function stateFromZip(zip) {
    var digits = String(zip || '').replace(/\D/g, '');
    if (digits.length < 3) return 'Illinois';
    var zip3 = parseInt(digits.slice(0, 3), 10);
    for (var i = 0; i < ZIP3_STATE.length; i++) {
      var row = ZIP3_STATE[i];
      if (zip3 >= row[0] && zip3 <= row[1]) return row[2];
    }
    return 'Illinois';
  }

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function jsonFetch(url, opts) {
    opts = opts || {};
    return fetch(url, {
      method: opts.method || 'GET',
      credentials: 'same-origin',
      headers: Object.assign(
        { Accept: 'application/json' },
        opts.body ? { 'Content-Type': 'application/json' } : {},
        opts.headers || {}
      ),
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function (res) {
      return res.text().then(function (text) {
        var data = null;
        try {
          data = text ? JSON.parse(text) : null;
        } catch (e) {
          data = null;
        }
        return { ok: res.ok, status: res.status, data: data, text: text };
      });
    });
  }

  function snapshotItems(cart) {
    var items = (cart && cart.items) || [];
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var props = it.properties || {};
      if (props._hh_est === '1') continue;
      var clean = {};
      Object.keys(props).forEach(function (k) {
        if (props[k] != null && props[k] !== '') clean[k] = props[k];
      });
      var line = { id: it.variant_id || it.id, quantity: it.quantity };
      if (Object.keys(clean).length) line.properties = clean;
      out.push(line);
    }
    return out;
  }

  function addItems(items) {
    if (!items || !items.length) return Promise.resolve();
    return jsonFetch('/cart/add.js', { method: 'POST', body: { items: items } });
  }

  function clearCart() {
    return jsonFetch('/cart/clear.js', { method: 'POST' });
  }

  function shippingQuery(zip, state) {
    return (
      'shipping_address[zip]=' +
      encodeURIComponent(zip) +
      '&shipping_address[country]=' +
      encodeURIComponent('United States') +
      '&shipping_address[province]=' +
      encodeURIComponent(state)
    );
  }

  function cheapestRate(rates) {
    if (!rates || !rates.length) return null;
    var best = null;
    for (var i = 0; i < rates.length; i++) {
      var r = rates[i];
      var price = parseFloat(r.price);
      if (!best || price < parseFloat(best.price)) best = r;
    }
    return best;
  }

  // Internal quote math: carrier rate + HH_BOXING_HANDLING. Do not disclose breakdown in UI.
  // Cart rates may already bake delivery-profile fixedFee into price (markup field).
  // Never double-count: strip known markup, then always add HH_BOXING_HANDLING.
  var HH_BOXING_HANDLING = 10;

  function formatMoney(n) {
    return '$' + (Math.round(n * 100) / 100).toFixed(2);
  }

  function customerShippingQuote(rate) {
    var listed = parseFloat(rate && rate.price);
    if (isNaN(listed)) return null;
    var markup = parseFloat(rate && rate.markup);
    var upsOnly = !isNaN(markup) && markup > 0 ? listed - markup : listed;
    if (upsOnly < 0) upsOnly = listed;
    var total = upsOnly + HH_BOXING_HANDLING;
    return {
      total: total,
      upsOnly: upsOnly,
      handling: HH_BOXING_HANDLING,
      name: (rate && rate.name) || 'Shipping'
    };
  }

  function formatShippingStatus(quote) {
    return quote.name + ' ' + formatMoney(quote.total);
  }

  function sleep(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  async function pollRates(query) {
    var tries = 0;
    while (tries < 12) {
      var res = await jsonFetch('/cart/async_shipping_rates.json?' + query);
      if (res.status !== 202) {
        var rates = (res.data && res.data.shipping_rates) || [];
        return Array.isArray(rates) ? rates : [];
      }
      tries += 1;
      await sleep(400);
    }
    return [];
  }

  async function estimate(root) {
    var handle = (root.getAttribute('data-handle') || '').toLowerCase();
    var variantId = root.getAttribute('data-variant');
    var btn = qs('#hh-ship-btn', root) || qs('#hh-ship-btn');
    var statusEl = qs('#hh-ship-status', root) || qs('#hh-ship-status');
    var zipInput = qs('#hh-ship-zip', root) || qs('#hh-ship-zip');

    if (!variantId || handle === 'cfi') return;

    var zip = ((zipInput && zipInput.value) || '60601').replace(/\s+/g, '');
    var zipDigits = zip.replace(/\D/g, '').slice(0, 5) || '60601';
    var state = stateFromZip(zipDigits);
    var original = [];

    function setStatus(msg) {
      if (statusEl) statusEl.textContent = msg || '';
    }

    if (btn) btn.disabled = true;
    setStatus('Estimating…');

    try {
      try {
        var cartRes = await jsonFetch('/cart.js');
        original = snapshotItems(cartRes.data || {});
        await clearCart();
        await jsonFetch('/cart/add.js', {
          method: 'POST',
          body: {
            items: [{ id: Number(variantId), quantity: 1, properties: { _hh_est: '1' } }]
          }
        });
        var q = shippingQuery(zipDigits, state);
        await jsonFetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST' });
        var rates = await pollRates(q);
        var best = cheapestRate(rates);
        if (!best) {
          setStatus(FAIL_MSG);
        } else {
          var quote = customerShippingQuote(best);
          if (!quote) {
            setStatus(FAIL_MSG);
          } else {
            setStatus(formatShippingStatus(quote));
          }
        }
      } catch (err) {
        setStatus(FAIL_MSG);
      }
    } finally {
      try {
        await clearCart();
        await addItems(original);
      } catch (restoreErr) {
        /* restore best-effort */
      }
      if (btn) btn.disabled = false;
    }
  }

  function bind() {
    var root = qs('.hh-ship-est');
    if (!root) return;
    var handle = (root.getAttribute('data-handle') || '').toLowerCase();
    if (handle === 'cfi') return;
    var form = qs('#hh-ship-form', root) || qs('form.hh-ship-form', root);
    if (form) {
      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        estimate(root);
      });
    }
    var btn = qs('#hh-ship-btn', root) || qs('#hh-ship-btn');
    if (btn && !form) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        estimate(root);
      });
    }
    var zipInput = qs('#hh-ship-zip', root) || qs('#hh-ship-zip');
    if (zipInput && !form) {
      zipInput.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.keyCode === 13) {
          ev.preventDefault();
          estimate(root);
        }
      });
    }
    // No auto-estimate on load: it POSTs /cart/add.js, which Shopify reports as
    // product_added_to_cart to every pixel (Google Ads ATC inflation, 2026-10-20).
  }

  function watchVariant() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.name === 'id' || (t.classList && t.classList.contains('product-variant-id')) || (t.classList && t.classList.contains('hh-model-select'))) {
        var root = qs('.hh-ship-est');
        if (root && t.value) root.setAttribute('data-variant', t.value);
      }
    });
    if (typeof subscribe === 'function') {
      try {
        var ev = (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) || 'variant-change';
        subscribe(ev, function (payload) {
          var variant = payload && payload.data && payload.data.variant;
          var root = qs('.hh-ship-est');
          if (root && variant && variant.id) root.setAttribute('data-variant', String(variant.id));
        });
      } catch (err) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bind();
      watchVariant();
    });
  } else {
    bind();
    watchVariant();
  }
})();
